import React from 'react';
import { Header } from './components/Header';
import { UrgencyBanner } from './components/UrgencyBanner';
import { MainContent } from './components/MainContent';
import { Footer } from './components/Footer';
import { StickyFooter } from './components/StickyFooter';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-50 pb-20" data-id="element-0">
      <Header data-id="element-1" />
      <UrgencyBanner data-id="element-2" />
      <MainContent data-id="element-3" />
      <Footer data-id="element-4" />
      <StickyFooter data-id="element-5" />
    </div>;
}